// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__u95u4","search":"Settings_search__3ke76","filter":"Settings_filter__2s_Ae"};